import React from 'react';
import { FormControl, TextField } from '@mui/material';
import { Controller } from 'react-hook-form';

export const FormTextField = ({
  label,
  name,
  control,
  rules = {},
  defaultValue = '',
  type = 'text',
  size = 'small',
  options,
  ...props
}) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      defaultValue={defaultValue}
      render={({
        field: { ref, value, ...inputProps },
        fieldState: { error },
      }) => (
        <FormControl fullWidth error={!!error}>
          <TextField
            value={value ?? ''}
            size={size}
            type={type}
            label={label}
            error={!!error}
            helperText={error?.message}
            inputRef={ref}
            {...inputProps}
            {...props}
            variant={props.disabled ? 'filled' : 'outlined'}
          />
        </FormControl>
      )}
    />
  );
};
